import React from 'react';

const SvgInfoIcon = props => (
  <svg
    data-name="ic_info"
    width={props.size || 80.197}
    height={props.size || 80.197}
    viewBox="0 0 80.197 80.197"
    fill="#104eb2"
    {...props}
  >
    <g
      id="alert_info_svg___002-alert"
      data-name="002-alert"
      transform="rotate(180 40.099 40.099)"
    >
      <path
        id="alert_info_svg__Path_207"
        d="M40.1 0a40.1 40.1 0 1040.1 40.1A40.144 40.144 0 0040.1 0zm0 77.112A37.014 37.014 0 1177.112 40.1 37.057 37.057 0 0140.1 77.112z"
        className="alert_info_svg__cls-1"
        data-name="Path 207"
      />
      <path
        id="alert_info_svg__Path_208"
        d="M1.542 0A1.542 1.542 0 000 1.542v33.93a1.542 1.542 0 003.084 0V1.542A1.542 1.542 0 001.542 0z"
        className="alert_info_svg__cls-1"
        data-name="Path 208"
        transform="translate(38.556 15.422)"
      />
      <path
        id="alert_info_svg__Path_209"
        d="M1.542 0A1.542 1.542 0 000 1.542v3.085a1.542 1.542 0 103.084 0V1.542A1.542 1.542 0 001.542 0z"
        className="alert_info_svg__cls-1"
        data-name="Path 209"
        transform="translate(38.556 57.063)"
      />
    </g>
  </svg>
);

export default SvgInfoIcon;
